module.exports = __webpack_public_path__ + "media/suprer6_ppair.54e3a84f.mp3";